import { BaseError } from '@nsftx/seven-client-retail-utils'
import type { DmCoreSpaceOperatorErrorType } from '#src/types/DmCoreSpaceOperatorErrorTypes'

export default class DmCoreSpaceOperatorError extends BaseError<DmCoreSpaceOperatorErrorType> {
  constructor(
    public message: string,
    public code: DmCoreSpaceOperatorErrorType,
    public options?: {
      cause?: unknown
    }
  ) {
    super(message, code, options)
    Object.setPrototypeOf(this, DmCoreSpaceOperatorError.prototype)
    this.name = this.constructor.name
  }
}
